"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _reactI18next = require("react-i18next");

var _constants = require("../../utils/constants");

var _Fade = _interopRequireDefault(require("@material-ui/core/Fade"));

var _LottieAnimate = _interopRequireDefault(require("../LottieAnimate"));

var CONTAINER_HEIGHT = 80;
var ANIMATE_HEIGHT = 400;
var OFFSET_Y = (ANIMATE_HEIGHT - CONTAINER_HEIGHT) / 2;

var InitialAnimation = function InitialAnimation(_ref) {
  var name = _ref.name,
      isLoading = _ref.isLoading,
      onAnimationComplete = _ref.onAnimationComplete,
      onAnimationError = _ref.onAnimationError,
      onAnimationDataFailed = _ref.onAnimationDataFailed;

  var _useTheme = (0, _styles.useTheme)(),
      palette = _useTheme.palette;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var currHour = new Date().getHours();
  var welcome = currHour >= 4 && currHour < 12 ? 'Good morning' : currHour >= 12 && currHour < 16 ? 'Good afternoon' : 'Hello';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-screen h-screen bg-app flex flex-col items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "overflow-hidden",
    style: {
      height: CONTAINER_HEIGHT
    }
  }, /*#__PURE__*/_react["default"].createElement(_LottieAnimate["default"], {
    className: "w-full",
    style: {
      width: ANIMATE_HEIGHT,
      transform: "translateY(-".concat(OFFSET_Y, "px)")
    },
    path: palette.type === _constants.themeMode.DARK ? t('onmail-loading-dark.json') : t('onmail-loading.json'),
    onComplete: onAnimationComplete,
    onError: onAnimationError,
    onDataFailed: onAnimationDataFailed
  })), /*#__PURE__*/_react["default"].createElement(_Fade["default"], {
    "in": !isLoading
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-4xl font-semibold text-dark w-full truncate px-10 text-center"
  }, welcome, ", ", name)));
};

var _default = InitialAnimation;
exports["default"] = _default;
//# sourceMappingURL=index.js.map